import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22.778 7.222c.707 4.95-1.414 9.192-4.596 12.374l-2.828 2.829-7.779-7.779 2.829-2.828c3.182-3.182 7.424-5.303 12.374-4.596" }, null, -1 /* CACHED */),
    _createElementVNode("circle", {
      cx: "15",
      cy: "12",
      r: "2",
      transform: "rotate(45 15 15)"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M10.05 12.172H5.808l-2.475 2.474 3.182 1.061m11.313 4.243v4.242l-2.474 2.475-1.061-3.182m-6.364-4.242-1.06 3.889 3.888-1.06" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }